import { cn } from '@/lib/utils'
import type { PanelArtProps } from './panel-art-props'

/**
 * Market Stats / Ticker Stats art (one drawing for both): four stat cards
 * across the top, each a caption over a bold figure, and a two-row metrics
 * table beneath with a label and value in each of two columns.
 */
const CARD_X = [12, 47, 82, 117]
const TABLE_ROWS = [56, 70]
const TABLE_COLUMNS: [number, number, number, number][] = [
  [12, 28, 50, 24],
  [86, 28, 124, 24],
]

export function MarketStatsArt({ className }: PanelArtProps) {
  return (
    <svg
      viewBox="0 0 160 100"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
      className={cn('h-full w-full', className)}
    >
      {CARD_X.map((x, i) => (
        <g key={x}>
          <rect
            x={x}
            y={12}
            width={31}
            height={28}
            rx={4}
            fill="hsl(var(--foreground) / 0.06)"
            stroke="hsl(var(--muted-foreground) / 0.22)"
            strokeWidth="1.5"
            vectorEffect="non-scaling-stroke"
          />
          <rect
            x={x + 5}
            y={18}
            width={16}
            height={3.5}
            rx={2}
            fill="hsl(var(--foreground) / 0.14)"
          />
          <rect
            x={x + 5}
            y={26}
            width={21 - (i % 2) * 4}
            height={9}
            rx={2}
            fill={i === 0 ? 'hsl(var(--primary) / 0.6)' : 'hsl(var(--foreground) / 0.3)'}
          />
        </g>
      ))}
      <path
        d="M12 47 H148"
        stroke="hsl(var(--muted-foreground) / 0.3)"
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
      />
      {TABLE_ROWS.map((y) =>
        TABLE_COLUMNS.map(([labelX, labelWidth, valueX, valueWidth]) => (
          <g key={`${y}-${labelX}`}>
            <rect
              x={labelX}
              y={y + 2}
              width={labelWidth}
              height={4}
              rx={2}
              fill="hsl(var(--foreground) / 0.12)"
            />
            <rect
              x={valueX}
              y={y}
              width={valueWidth}
              height={8}
              rx={2}
              fill="hsl(var(--foreground) / 0.32)"
            />
          </g>
        )),
      )}
    </svg>
  )
}
